module.exports = __webpack_public_path__ + "img/bishuiwan.f341e32e.png";